import React, { useState } from "react";
import { Card, CardContent } from "../../components/ui/card";
import OrganizationMenu from "./OrganizationMenu";
import CategoryFileManager from "./CategoryFileManager";
import { useIsMobile } from "../../hooks/use-mobile";

const FilesDashboard = () => {
  const [selectedCategory, setSelectedCategory] = useState<{ orgId: string; categoryId: string } | null>(null);
  const isMobile = useIsMobile();

  const handleCategorySelect = (orgId: string, categoryId: string) => {
    setSelectedCategory({ orgId, categoryId });
  };

  return (
    <div className="container py-4 sm:py-6 space-y-4 sm:space-y-6 h-full overflow-auto">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <h1 className="text-2xl sm:text-3xl font-bold">Document Management System</h1>
        {isMobile && selectedCategory && (
          <OrganizationMenu
            onCategorySelect={handleCategorySelect}
            selectedCategory={selectedCategory}
            isMobile={true}
          />
        )}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 sm:gap-6">
        {!isMobile && (
          <Card className="lg:col-span-1">
            <CardContent className="p-4">
              <h2 className="text-lg sm:text-xl font-semibold mb-4">Organizations</h2>
              <OrganizationMenu
                onCategorySelect={handleCategorySelect}
                selectedCategory={selectedCategory}
                isMobile={false}
              />
            </CardContent>
          </Card>
        )}

        <Card className={isMobile ? "col-span-1" : "lg:col-span-3"}>
          <CardContent className="p-4 sm:p-6">
            {selectedCategory ? (
              <CategoryFileManager
                organization={selectedCategory.orgId}
                category={selectedCategory.categoryId}
              />
            ) : (
              <div className="text-center py-8 sm:py-12">
                <div className="text-muted-foreground mb-4">
                  <p className="text-base sm:text-lg">Welcome to Document Management</p>
                  <p className="text-sm sm:text-base">Select an organization and category {isMobile ? 'from the menu above' : 'from the left menu'} to get started</p>
                </div>
                <div className="space-y-2 text-xs sm:text-sm">
                  <p><strong>ByteSplash:</strong> Course certificates, offer letters, materials, and more</p>
                  <p><strong>Margey Labs:</strong> Internship certificates, HR resources, and documentation</p>
                </div>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default FilesDashboard;
